import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { GameCard } from "../../card";
import PopUpCard from "../../card/popUpCard";
import arrow from "../../../assets/images/icons/arrow-right-light.svg";
import GAHArrow from "../../../assets/images/GAH/Arrow.png";
import trophy from "../../../assets/images/icons/trophy.svg";
import cx from "classnames";
import bgImage from "./modal-bg.jpg";
import ResultBg from "./bg-image.jpg";
import classes from "./styles.module.scss";
import ResultBanner from "../../../assets/images/GAH/result-banner.svg";
import City from "../../../assets/images/City.png";

export default (props) => {
  let { isOpen, toggle, modalCard, promptText, roomData, className } = props;
  let gameStatus = roomData.game_state.status;
  let winnerUser = {};
  if (roomData && roomData.game_state && roomData.game_state.played_cards) {
    let playedCards = roomData.game_state.played_cards;
    let winner = playedCards.filter((val) => val.winner === true);
    if (winner && winner.length > 0) {
      modalCard = winner[0];
    }

    if (winner && winner.length > 0) {
      winnerUser = roomData.users.filter(
        (user) => user?.player_id === winner[0]?.player_id
      );
      winnerUser = winnerUser[0];
    }
  }

  const BodyContent = (props) => {
    const { className = "", GAH } = props;
    const errorImage =
      "https://media.giphy.com/media/Ke8JKfxe83FpLrra71/giphy.gif";
    let firstName = "";
    if (winnerUser && winnerUser.display_name !== undefined) {
      firstName = winnerUser.display_name.split(" ");
    }

    return (
      <div
        className={cx(
          "game-cardModalContent ",
          className,
          {
            gif: modalCard && modalCard.flipped ? modalCard.card.gif_url : "",
          },
          {
            [" h-100 d-flex flex-column justify-content-end"]:
              gameStatus === "Result",
          },
          {
            ["flex-grow-1"]: roomData.game_code !== "GAH",
          }
        )}
      >
        {/* {gameStatus === "Result" && (
          <div className="score">
            <p>
              <img src={trophy} alt="trophy" />
              {`${winnerUser.display_name}  Scores!`}
            </p>
          </div>
        )} */}
        {gameStatus === "Result" ? (
          <div className="score">
            <div className="winningGifWrapper">
              <div className="top-image">
                <img
                  src={ResultBanner}
                  alt="trophy"
                  className="winningTopBanner"
                />{" "}
                <p>
                  <span>{`${firstName[0]}  Scores!`}</span>
                </p>
              </div>
              <div className="winningGifDiv">
                <img
                  src={modalCard.card.gif_url}
                  alt="trophy"
                  className="winningGif"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center contentCardWrapper ">
            <div>
              <div className="bg-theme br-16 contentCard">
                <div className="text-highlight content">
                  <p className="promptText">{promptText}</p>
                </div>
              </div>
            </div>
            {GAH ? (
              <img src={GAHArrow} className="mx-3 gah-arrow" alt="arrow" />
            ) : (
              <img src={arrow} className="mx-3" alt="arrow" />
            )}
            <div className="PopUpCardWrapper">
              <PopUpCard
                modalCard={modalCard}
                // imageClassName={classes.imageSize}
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  // if (gameStatus === "Result") {
  //   return <BodyContent />;
  // }
  let prompt = roomData.game_state.prompt.split("[BLANK]");
  return (
    <>
      {gameStatus === "Reading" && (
        <Modal
          backdrop={false}
          isOpen={isOpen}
          toggle={toggle}
          size="lg"
          centered
          className={cx("game-cardModal gahModal", className, {
            autoSize:
              (modalCard && modalCard.flipped && modalCard.card.gif_url) ||
              true,
          })}
        >
          {roomData?.game_code === "GAH" ? (
            <ModalBody
              style={{
                background: "rgba(171, 246, 255, 0.5)",
                border: "2px solid #63989C",
                backgroundImage: `url(${City})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
              className={{
                "flex-column": gameStatus === "Result",
              }}
            >
              <BodyContent className="modalView gahModalView" GAH={true} />
              {/* <div className="bottom-text">
								<p className="mb-0">
									{roomData.game_state.prompt.replace(
										/\[BLANK]/g,
										"____"
									)}
								</p>
							</div> */}
            </ModalBody>
          ) : (
            <ModalBody
              style={{
                backgroundImage: `url(${
                  gameStatus === "Result" ? ResultBg : bgImage
                })`,
              }}
              className={{
                "flex-column": gameStatus === "Result",
              }}
            >
              <BodyContent className="modalView" />
            </ModalBody>
          )}
        </Modal>
      )}

      {modalCard.flipped && (
        <Modal
          backdrop={false}
          isOpen={isOpen}
          toggle={toggle}
          size="lg"
          centered
          className={cx("game-cardModal gahModal", className, {
            autoSize:
              (modalCard && modalCard.flipped && modalCard.card.gif_url) ||
              true,
          })}
        >
          {roomData?.game_code === "GAH" ? (
            <ModalBody
              style={{
                background: "rgba(171, 246, 255, 0.5)",
                border: "2px solid #63989C",
                backgroundImage: `url(${City})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
              className={{
                "flex-column": gameStatus === "Result",
              }}
            >
              <BodyContent className="modalView gahModalView" GAH={true} />
              {gameStatus === "Result" && (
                <div className="bottom-text">
                  <p className="mb-0">
                    {prompt[0] ? prompt[0] : roomData.game_state.prompt}
                    <span> {modalCard.card.text}</span>
                    {prompt[1] ? (prompt[1] !== "." ? prompt[1] : "") : ""}
                  </p>
                </div>
              )}
            </ModalBody>
          ) : (
            <ModalBody
              style={{
                backgroundImage: `url(${
                  gameStatus === "Result" ? ResultBg : bgImage
                })`,
              }}
              className={{
                "flex-column": gameStatus === "Result",
              }}
            >
              <BodyContent className="modalView" />
            </ModalBody>
          )}
        </Modal>
      )}
    </>
  );
};
